import type { Requests } from "../common/request.common";
import type { FinancePaymentResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const financePayment = {
    obtain(invoiceId: string, nonce: string) {
        return get<FinancePaymentResponseTypes.Obtain>(
            `/finance-payment/obtain/${invoiceId}?${nonce}`,
            {
                authenticated: false,
            },
        );
    },
    create(invoiceId: string, data: typeof Requests.FinancePayment.Create.Input) {
        return post<typeof data, FinancePaymentResponseTypes.Create>(
            `/finance-payment/create/${invoiceId}`,
            data,
            { authenticated: false },
        );
    },
    update(invoiceId: string, data: typeof Requests.FinancePayment.Update.Input) {
        return post<typeof data>(`/finance-payment/update/${invoiceId}`, data);
    },
    cancel(invoiceId: string) {
        return postEmpty(`/finance-payment/cancel/${invoiceId}`, { authenticated: false });
    },
    obtainFees(invoiceId: string) {
        return get<FinancePaymentResponseTypes.ObtainFees>(
            `/finance-payment/obtain-fees/${invoiceId}`,
            {
                authenticated: false,
            },
        );
    },
};
